import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiParentProfile, ApiPerk, ApiSitterProfile, ApiUser, ApiUserProfile } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse } from '@app/packages/api/v2/types/misc'
import type { ProfileUpdateRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getUsersById = (id: string) =>
  createApiAction('getUsersById', dispatch => dispatch<ApiDataResponse<ApiUser>>({ method: 'GET', endpoint: urlEscaped`/api/v2/users/${id}` }))

export const getUsersByToken = (token: string) =>
  createApiAction('getUsersByToken', dispatch => dispatch<ApiDataResponse<ApiUser>>({ method: 'GET', endpoint: urlEscaped`/api/v2/users/by_token/${token}` }))

export const getUsersByChatUid = (chatUid: string) =>
  createApiAction('getUsersByChatUid', dispatch =>
    dispatch<ApiDataResponse<ApiUser>>({ method: 'GET', endpoint: urlEscaped`/api/v2/users/by_chat_uid/${chatUid}` })
  )

export const getUsersByFilter = (filter: { ids: string[]; account_type: 'parent' | 'sitter' }) =>
  createApiAction('getUsersByFilter', dispatch =>
    dispatch<ApiDataResponse<ApiUser[]>>({
      method: 'GET',
      endpoint: v2Path('/api/v2/users', { 'filter[id]': filter.ids, 'filter[account_type]': filter.account_type }),
    })
  )

export const getUsersMe = () =>
  createApiAction('getUsersMe', dispatch =>
    dispatch<ApiDataResponse<ApiUserProfile>>({
      method: 'GET',
      endpoint: '/api/v2/users/me',
    })
  )

export const putUsersById = (id: string, request: ProfileUpdateRequest) =>
  createApiAction('putUsersById', dispatch =>
    dispatch<ApiDataResponse<ApiSitterProfile | ApiParentProfile>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/users/${id}`,
      body: JSON.stringify(request),
    })
  )

export const deleteUsersById = (id: string) =>
  createApiAction('deleteUsersById', dispatch => dispatch<ApiDataResponse<ApiUserProfile>>({ method: 'DELETE', endpoint: urlEscaped`/api/v2/users/${id}` }))

export const getUsersByIdPerks = (user_id: string) =>
  createApiAction('getUsersByIdPerks', dispatch =>
    dispatch<ApiDataResponse<ApiPerk[]>>({ method: 'GET', endpoint: urlEscaped`/api/v2/users/${user_id}/perks` })
  )

export const putUsersByIdPerks = (user_id: string, perk_ids: string[]) =>
  createApiAction('putUsersByIdPerks', dispatch =>
    dispatch<ApiDataResponse<ApiPerk[]>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/users/${user_id}/perks`, body: JSON.stringify({ perk_ids }) })
  )
